import React from "react"
import { Flex } from "@capioweb/ui-components/src"
import {
	PageBaseProps,
	BreadcrumbItemProps,
} from "../../components/Core/pageBase"
import { BreadcrumbsBlock } from "../../components"
import { LoginSharedForm } from "./components"
import {
	LoginSharedFormContextProvider,
	LoginSharedFormContext,
} from "./context/LoginSharedFormContext"
import { SharedFormProps } from "../../@types/CapioWeb/core"

interface ResetPasswordPageProps extends PageBaseProps {
	breadcrumb: Array<BreadcrumbItemProps>
	resetPasswordForm: SharedFormProps
	resetSuccessForm: SharedFormProps
}

const ResetPasswordPage: React.FC<ResetPasswordPageProps> = ({
	breadcrumb,
	resetPasswordForm,
	resetSuccessForm,
}) => {
	const { setActiveFormVariant } = React.useContext(LoginSharedFormContext)

	React.useEffect(() => {
		setActiveFormVariant("resetPasswordForm")
	}, [setActiveFormVariant])

	return (
		<Flex display="block" w={1}>
			<BreadcrumbsBlock items={breadcrumb} />
			<Flex w={1} py={8} px={3} backgroundColor="greyEE">
				<LoginSharedFormContextProvider defaultFormVariant="resetPasswordForm">
					<LoginSharedForm
						forms={{
							resetPasswordForm,
							resetSuccessForm,
						}}
					/>
				</LoginSharedFormContextProvider>
			</Flex>
		</Flex>
	)
}

export { ResetPasswordPage }
